/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AnalyticsSignalDefinition = {
  capturedAt: Date;
  definition: { [k: string]: any };
  definitionHash: string;
  sensorId: string;
};

/** @internal */
export const AnalyticsSignalDefinition$inboundSchema: z.ZodMiniType<
  AnalyticsSignalDefinition,
  unknown
> = z.pipe(
  z.object({
    captured_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    definition: z.record(z.string(), z.any()),
    definition_hash: z.string(),
    sensor_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "captured_at": "capturedAt",
      "definition_hash": "definitionHash",
      "sensor_id": "sensorId",
    });
  }),
);

export function analyticsSignalDefinitionFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalDefinition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalDefinition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalDefinition' from JSON`,
  );
}
